import React, { Component } from "react";

class Bank extends Component {
  render() {
    return (
      <div>
        <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <a href="Default.aspx" className="a-breadcrumbs">หน้าแรก</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">บริการของเรา</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="Purpose.aspx" className="a-breadcrumbs">ช่องทางการโอนเงินเข้าบัญชี</a>
              </div>
            </div>
          </div>
        </section>

        <section className="page-section">
          <div className="container">
            <div className="row">
              <div className="col-md-9 col-sm-9 mb-sm-50" style={{fontFamily: '"Cordia New"',fontSize: 20}}>
                <h2 className="title-section mt-0 mb-0"><span>ช่องทางการโอนเงินเข้าบัญชี</span></h2><br/>
                <div class="divider gray left mt-20 mb-25"></div>
                <img src="Img/Board/PayBank.png" width="800" />
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Bank;
